export default __webpack_public_path__ + "static/media/background-left.7da59316.png";